import { putApi } from "./api_instance";

export const submitReceipt = async (transactionId, info, dispatch) => {
  try {
    const { data } = await putApi({
      apiUrl: `/payments/api/wallet/submit-payment/${transactionId}`,
      dispatch,
      sendToken: true,
      data: info,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
